import React from 'react';

const timelineItems = [
  {
    title: 'Design approval',
    description: 'Kitchen layout approved by client.',
    meta: 'Sarah R.  ·  Feb 14, 2027',
    image: 'https://customer-assets.emergentagent.com/job_dc9e3538-f079-41ff-9232-076517c20916/artifacts/dvbrqdmd_image.png',
  },
  {
    title: 'Vendor approved',
    description: 'Stone slab approved - Atelier Stone',
    meta: 'John M.  ·  Feb 13, 2027',
    image: 'https://customer-assets.emergentagent.com/job_dc9e3538-f079-41ff-9232-076517c20916/artifacts/q6tcpmo9_image.png',
  },
  {
    title: 'Specification change',
    description: 'Faucet specification updated',
    meta: 'Emily R.  ·  Feb 12, 2027',
    image: 'https://customer-assets.emergentagent.com/job_dc9e3538-f079-41ff-9232-076517c20916/artifacts/qmkhicbh_image.png',
  },
  {
    title: 'Client preference saved',
    description: 'Prefers warmer metals and natural stone',
    meta: null,
    image: null,
  },
];

export const HeroTimeline = () => (
  <div className="relative flex flex-col items-center animate-[heroRise_0.9s_ease-out_0.1s_both]">
    <div data-testid="hero-timeline-stage" className="relative w-full max-w-[760px] h-[540px]">
      <div className="absolute left-[calc(50%-40px)] top-0 -translate-x-1/2 z-20 w-[400px] md:w-[430px]">
        <div
          className="bg-white rounded-[22px] shadow-[0_30px_70px_rgba(60,45,30,0.16)] px-7 pt-7 pb-12"
          style={{
            maskImage: 'linear-gradient(to bottom, #000 78%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, #000 78%, transparent 100%)',
          }}
        >
          <div className="flex items-center gap-2 mb-6 px-1">
            <span className="text-[#1F1812] text-[22px]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}>
              Project Timeline
            </span>
            <svg className="w-4 h-4 text-[#8B7355]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          <div className="relative">
            <div className="absolute left-[3px] top-3 bottom-3 w-px bg-[#E8E0D5]" />
            <div className="space-y-7">
              {timelineItems.map((item) => (
                <div key={item.title} className="relative grid grid-cols-[1fr_76px] gap-4 items-center pl-6">
                  <div className="absolute left-0 top-[7px] w-[8px] h-[8px] rounded-full bg-[#9B8B76] ring-[3px] ring-white" />
                  <div className="min-w-0">
                    <p className="text-[#1F1812] text-[16px] font-semibold leading-tight">{item.title}</p>
                    <p className="text-[#7A6B58] text-[13.5px] mt-1.5 leading-snug">{item.description}</p>
                    {item.meta && <p className="text-[#A89888] text-[12px] mt-2">{item.meta}</p>}
                  </div>
                  {item.image ? (
                    <div className="w-[76px] h-[76px] rounded-xl overflow-hidden bg-[#F3EDE4]">
                      <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                    </div>
                  ) : (
                    <div className="w-[76px]" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div data-testid="hero-logos" className="mt-3 text-center w-full relative z-30 animate-[heroRise_1s_ease-out_0.2s_both]">
      <p className="text-[#8B7355] text-[12px] tracking-wide mb-4">Works with the tools you already use</p>
      <div className="flex justify-center">
        <div className="inline-flex items-center gap-7 md:gap-9 bg-white rounded-2xl px-9 py-4 shadow-[0_16px_44px_rgba(60,45,30,0.12)]">
          <svg className="h-6 w-auto" viewBox="0 0 48 48">
            <path fill="#4caf50" d="M45,16.2l-5,2.75l-5,4.75L35,40h7c1.657,0,3-1.343,3-3V16.2z" />
            <path fill="#1e88e5" d="M3,16.2l3.614,1.71L13,23.7V40H6c-1.657,0-3-1.343-3-3V16.2z" />
            <polygon fill="#e53935" points="35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17" />
            <path fill="#c62828" d="M3,12.298V16.2l10,7.5V11.2L9.876,8.859C9.132,8.301,8.228,8,7.298,8h0C4.924,8,3,9.924,3,12.298z" />
            <path fill="#fbc02d" d="M45,12.298V16.2l-10,7.5V11.2l3.124-2.341C38.868,8.301,39.772,8,40.702,8h0C43.076,8,45,9.924,45,12.298z" />
          </svg>
          <svg className="h-6 w-auto" viewBox="0 0 24 24">
            <rect x="9" y="5" width="13" height="14" rx="1.5" fill="#0F4B8C" />
            <rect x="2" y="6.5" width="11" height="11" rx="2" fill="#1A88E0" />
            <ellipse cx="7.5" cy="12" rx="2.5" ry="3.1" fill="none" stroke="#fff" strokeWidth="1.7" />
          </svg>
          <svg className="h-6 w-auto" viewBox="0 0 48 48">
            <path fill="#33d375" d="M33,8c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,1.3,0,9.7,0,11c0,2.2,1.8,4,4,4s4-1.8,4-4C33,17.7,33,9.3,33,8z" />
            <path fill="#33d375" d="M43,19c0,2.2-1.8,4-4,4c-1.2,0-4,0-4,0s0-3,0-4c0-2.2,1.8-4,4-4S43,16.8,43,19z" />
            <path fill="#40c4ff" d="M8,33c-2.2,0-4-1.8-4-4s1.8-4,4-4c1.3,0,9.7,0,11,0c2.2,0,4,1.8,4,4s-1.8,4-4,4C17.7,33,9.3,33,8,33z" />
            <path fill="#40c4ff" d="M19,43c-2.2,0-4-1.8-4-4c0-1.2,0-4,0-4s3,0,4,0c2.2,0,4,1.8,4,4S21.2,43,19,43z" />
            <path fill="#e91e63" d="M40,33c2.2,0,4-1.8,4-4s-1.8-4-4-4c-1.3,0-9.7,0-11,0c-2.2,0-4,1.8-4,4s1.8,4,4,4C30.3,33,38.7,33,40,33z" />
            <path fill="#e91e63" d="M29,43c2.2,0,4-1.8,4-4c0-1.2,0-4,0-4s-3,0-4,0c-2.2,0-4,1.8-4,4S26.8,43,29,43z" />
            <path fill="#ffc107" d="M15,8c0-2.2,1.8-4,4-4s4,1.8,4,4c0,1.3,0,9.7,0,11c0,2.2-1.8,4-4,4s-4-1.8-4-4C15,17.7,15,9.3,15,8z" />
            <path fill="#ffc107" d="M5,19c0,2.2,1.8,4,4,4c1.2,0,4,0,4,0s0-3,0-4c0-2.2-1.8-4-4-4S5,16.8,5,19z" />
          </svg>
          <svg className="h-6 w-auto" viewBox="0 0 87.3 78" fill="none">
            <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z" fill="#0066da" />
            <path d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z" fill="#00ac47" />
            <path d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z" fill="#ea4335" />
            <path d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d" />
            <path d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc" />
            <path d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00" />
          </svg>
          <svg className="h-5 w-auto" viewBox="0 0 24 24" fill="#0061FF">
            <path d="M6 1.8L0 5.6l6 3.8 6-3.8L6 1.8zM18 1.8l-6 3.8 6 3.8 6-3.8-6-3.8zM0 13.2l6 3.8 6-3.8-6-3.8-6 3.8zM18 9.4l-6 3.8 6 3.8 6-3.8-6-3.8zM6 18.7l6 3.8 6-3.8-6-3.8-6 3.8z" />
          </svg>
        </div>
      </div>
    </div>
  </div>
);

export default HeroTimeline;
